import { makeStyles, createStyles, MuiTheme } from '@kis-technologies/kis-ui';

export const useStyles = makeStyles((theme: MuiTheme) =>
  createStyles({
    infoViewOuterContainer: {
      alignItems: 'center',
      justifyContent: 'center',
      padding: '0px 24px 24px 24px',
      minWidth: '100%',
      background: 'transparent'
    },
    infoViewInnerContainer: {
      background: 'white',
      color: '#2A2A2A',
      minWidth: '100%',
      borderRadius: '8px',
      height: '809px',
      boxShadow: '0 3px 9px 0 rgba(0,0,0,0.2)',
      padding: '32px 80px 32px 80px',
      overflow: 'hidden',
      [theme.breakpoints.down('lg')]: {
        height: '1600px',
        padding: '48px 23px 32px 32px'
      }
    },
    infoViewHeaderLabel: {
      fontWeight: 600,
      fontSize: '56px',
      margin: '0px',
      letterSpacing: 0,
      [theme.breakpoints.down('lg')]: {
        fontSize: '64px'
      }
    },
    infoViewLandscapeContainer: {
      display: 'flex',
      [theme.breakpoints.down('lg')]: {
        display: 'none'
      }
    },
    infoViewPortraitContainer: {
      display: 'none',
      [theme.breakpoints.down('lg')]: {
        display: 'flex',
        height: '1430px',
        padding: '0px 0px 67px 0px'
      }
    },
    infoPortraitImageBlock: {
      width: '50%',
      paddingRight: '20px'
    },
    infoPortraitTextBlock: {
      width: '50%',
      paddingRight: '20px'
    },
    infoRenderActionContainer: {
      background: 'transparent',
      minWidth: '100%',
      display: 'flex',
      flexDirection: 'row',
      [theme.breakpoints.down('lg')]: {
        flexDirection: 'column'
      }
    },
    infoActionImageContainer: {
      background: 'transparent',
      padding: '16px 32px 16px 32px',
      minHeight: '100%',
      display: 'flex',
      flexDirection: 'column',
      [theme.breakpoints.down('lg')]: {
        padding: '16px 0px 16px 0px'
      }
    },
    infoActionOverlayImageBlock: {
      width: '560px',
      height: '420px',
      background: 'transparent',
      display: 'flex',
      flexDirection: 'row',
      [theme.breakpoints.down('lg')]: {
        width: '100%',
        justifyContent: 'center'
      }
    },
    infoViewImage: {
      width: '70%',
      objectFit: 'scale-down',
      [theme.breakpoints.down('lg')]: {
        width: '100%'
      }
    },
    infoViewDividerLandscape: {
      flex: '1 1 0%',
      maxHeight: '15px',
      background: 'transparent',
      padding: '12px 0px 12px 0px',
      display: 'flex',
      [theme.breakpoints.down('lg')]: {
        display: 'none'
      }
    },
    infoViewDividerPortrait: {
      display: 'none',
      [theme.breakpoints.down('lg')]: {
        flex: '1 1 0%',
        maxHeight: '15px',
        background: 'transparent',
        padding: '12px 0px 12px 0px',
        display: 'flex'
      }
    },
    infoActionOverlayHeaderBlock: {
      width: '560px',
      background: 'transparent',
      margin: '0px 0px 0px  0px',
      display: 'flex',
      flexDirection: 'column'
    },
    infoViewDescriptionBox: {
      height: '690px',
      width: '850px',
      background: 'transparent',
      [theme.breakpoints.down('lg')]: {
        height: '450px',
        width: '955px'
      }
    }
  })
);
